module.exports = __webpack_public_path__ + "static/FabrigaMedium-95821173c2a52eec6e2139e79e5c52dc.woff";